import { ListProjects } from "@stories/pages/ListProjects/ListProjects";

export const ListProjectsView = () => {
  return <ListProjects />;
};
